import i18next from 'i18next';

import { useAppSelector } from '../../../../store/hooks';
import { selectedMultiStoreOrigin } from '../../../../store/multi-store';
import { useMultiStoreCandidates } from './use-multi-store';

// sorted: sottotitolo del pannello. Il pannello segue l'ordine della scelta del centro (step
// "dove"): per distanza solo con la posizione del cliente, altrimenti nell'ordine del layout,
// e la distanza dal centro di partenza resta solo un'informazione («Distanze da …»).
// distances: riga sotto «Dove vuoi andare», dice solo da dove si misura
type DistanceReferenceKind = 'sorted' | 'distances';

const KEYS: Record<
  DistanceReferenceKind,
  { fromYou: string; fromCenter: string }
> = {
  sorted: {
    fromYou: 'pages.when.multi_store.sorted_from_you',
    fromCenter: 'pages.when.multi_store.distances_from_center',
  },
  distances: {
    fromYou: 'pages.when.multi_store.distances_from_you',
    fromCenter: 'pages.when.multi_store.distances_from_center',
  },
};

// Da dove si misurano le distanze dei candidati: dal cliente se nello step "dove" ha
// indicato la sua posizione, altrimenti dal centro di partenza (lo decide il backend)
export const useDistanceReference = (kind: DistanceReferenceKind): string => {
  const { data } = useMultiStoreCandidates();
  const origin = useAppSelector(selectedMultiStoreOrigin);
  const keys = KEYS[kind];

  return data?.[0]?.isDistanceFromCustomer === true
    ? i18next.t(keys.fromYou)
    : i18next.t(keys.fromCenter, { name: origin.name });
};
